import { Card, Spin, Tooltip, Transfer } from "antd";
import { TransferDirection } from "antd/es/transfer";
import React, { useEffect, useState } from "react";
import { getEvent } from "../../services/EventService";
import { Axios, AxiosResponse } from "axios";
import "./participantAgenda.scss";
import { ClockCircleOutlined, PicCenterOutlined } from "@ant-design/icons";
import moment from "moment";
import { Typography } from "antd";
import { EventDto } from "../../models/Event";
import { Agenda } from "../../models/Agenda";

function ParticipantInAgenda(props: any) {
  const [selectedEvent, setSelectedEvent] = useState<EventDto>();
  const [allAgendasFalse, setAllAgendasFalse] = useState<Agenda[]>([]);
  const [allAgendasTrue, setAllAgendasTrue] = useState<Agenda[]>([]);
  const [activeSpinner, setActiveSpinner] = useState<boolean>(false);
  const { Text } = Typography;

  useEffect(() => {
    setActiveSpinner(true);
    getEvent(props?.oneParticipant?.event?.id).then((res: AxiosResponse) => {
      let data = res?.data?.result;
      setSelectedEvent(data);
      let arr: Agenda[] = [];
      let arr1: Agenda[] = [];

      data?.agendas?.forEach((ag: Agenda) => {
        props?.oneParticipant?.agenda?.some((agg: Agenda) => {
          if (ag.id == agg.id) {
            arr.push(ag);
          }
        });
      });

      data?.agendas?.forEach((ag: Agenda) => {
        const hasDuplicate = props?.oneParticipant?.agenda?.some(
          (agg: Agenda) => {
            return agg.id === ag.id;
          }
        );

        if (!hasDuplicate) {
          arr1.push(ag);
        }
      });

      let truePart = arr?.filter(
        (agenda: Agenda) => agenda?.instructorName == null
      );

      let falsePart = arr1?.filter(
        (agenda: Agenda) => agenda?.instructorName == null
      );

      truePart.sort(function (a, b) {
        const dateTimeA: Date = new Date(a.time[0]);
        const dateTimeB: Date = new Date(b.time[0]);

        // Prvo poredi po datumu
        const dateComparison = dateTimeA.getTime() - dateTimeB.getTime();
        if (dateComparison !== 0) {
          return dateComparison;
        }

        // Ako su datumi isti, poredi po vremenu
        const timeA: Date = new Date(a.time[1]);
        const timeB: Date = new Date(b.time[1]);
        return timeA.getTime() - timeB.getTime();
      });

      falsePart.sort(function (a, b) {
        const dateTimeA: Date = new Date(a.time[0]);
        const dateTimeB: Date = new Date(b.time[0]);

        // Prvo poredi po datumu
        const dateComparison = dateTimeA.getTime() - dateTimeB.getTime();
        if (dateComparison !== 0) {
          return dateComparison;
        }

        // Ako su datumi isti, poredi po vremenu
        const timeA: Date = new Date(a.time[1]);
        const timeB: Date = new Date(b.time[1]);
        return timeA.getTime() - timeB.getTime();
      });

      if (props?.oneParticipant?.agenda.length == 0) {
        setAllAgendasFalse(data?.agendas);
      } else {
        setAllAgendasTrue(truePart);
        setAllAgendasFalse(falsePart);
      }
      setActiveSpinner(false);
    });
  }, [props]);

  console.log("All", allAgendasFalse);

  return (
    <Spin spinning={activeSpinner}>
      <div className="transfer-c">
        {" "}
        <h4>Događaj : {selectedEvent?.name}</h4>
        <div className="card-divs">
          <Card
            title="Prisustvovao"
            extra={
              <>
                Agenda: <b>{allAgendasTrue.length}</b>
              </>
            }
            style={{ width: 300 }}
          >
            {allAgendasTrue?.map((agenda: Agenda, i: number) => {
              return (
                <div className="one-agend">
                  <Tooltip
                    title={`${i + 1}. 
                  ${agenda.title}`}
                  >
                    <Text ellipsis style={{ width: "350px" }}>
                      {" "}
                      {`${i + 1}. `}
                      {agenda.title}
                    </Text>
                  </Tooltip>
                  <span>
                    {moment(agenda?.date).format("YYYY-MM-DD")}; {""}
                    {moment(agenda?.time[0]).format("HH:mm")}-
                    {moment(agenda?.time[1]).format("HH:mm")}
                    <ClockCircleOutlined
                      style={{ marginLeft: "10px", color: "#55ad5b" }}
                    />
                  </span>
                </div>
              );
            })}
          </Card>
          <div className="davider">
            <PicCenterOutlined />
          </div>
          <Card
            title="Nije prisustvovao"
            extra={
              <>
                Agenda: <b>{allAgendasFalse.length}</b>
              </>
            }
            style={{ width: 300 }}
          >
            {allAgendasFalse?.map((agenda: Agenda, i: number) => {
              return (
                <div className="one-agend">
                  <Tooltip
                    title={`${i + 1}. 
                  ${agenda.title}`}
                  >
                    <Text ellipsis style={{ width: "350px" }}>
                      {" "}
                      {`${i + 1}. `}
                      {agenda.title}
                    </Text>
                  </Tooltip>
                  <span>
                    {moment(agenda?.date).format("DD.MM.YYYY")}; {""}
                    {moment(agenda?.time[0]).format("HH:mm")}-
                    {moment(agenda?.time[1]).format("HH:mm")}
                    <ClockCircleOutlined
                      style={{ marginLeft: "10px", color: "#C7363D" }}
                    />
                  </span>
                </div>
              );
            })}
          </Card>
        </div>
      </div>
    </Spin>
  );
}

export default ParticipantInAgenda;
